import React, { useContext } from "react";
import { useState } from "react";
import RedAccordianArrowDown from "../../Assets/Images/AccordianArrowDown.svg";
import TealAccordianArrowDown from "../../Assets/Images/TealAccordianDown.svg";
import "../../Assets/Styles/FAQs.css";
import {
  categoriesEng,
  categoriesSpanish,
  faqs,
} from "../../constants/DummyValueConstants";
import HealthInsuranceHero from "../HealthInsuranceHero";
import NavBar from "../../Components/NavBar";
import { LanguageContext } from "../../Hooks/langugaeContext";
import {
  FAQTableDefaultEng,
  FAQTableDefaultSpanish,
} from "../../constants/FAQTable";
import Select from "react-dropdown-select";

export const FAQSHelp = () => {
  // language translation code
  const { language } = useContext(LanguageContext);
  const FAQTableDefault =
    language === "Eng" ? FAQTableDefaultEng : FAQTableDefaultSpanish;
  const categories = language === "Eng" ? categoriesEng : categoriesSpanish;

  const [activeCategory, setActiveCategory] = useState(categories[0].name);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const allCategories = categories.map((x) => ({
    label: x.name,
    value: x.name,
  }));

  return (
    <>
      <NavBar onlyWhiteBg />
      <div className="min-h-screen container pt-36 pb-20">
        <h1 className="text-3xl font-bold text-center mb-12">
          How can we help?
        </h1>

        <div className="mx-4 my-12 block md:hidden">
          <label
            htmlFor="networkSelect"
            className="block px-2 py-2 mb-2 font-semibold"
          >
            Search By Category
          </label>
          <div className="relative">
            <Select
              className="dropdwon-bg-white"
              options={allCategories}
              labelField="label"
              valueField="value"
              values={
                activeCategory
                  ? [{ label: activeCategory, value: activeCategory }]
                  : []
              }
              onChange={(values) => setActiveCategory(values[0]?.value || null)}
              placeholder="Select Category"
            />
          </div>
        </div>
        {/* <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-12  hidden md:grid">
          {categories.map((category) => (
            <button
              key={category.name}
              onClick={() => setActiveCategory(category.name)}
              className={`flex flex-col items-center p-4 rounded-lg ${
                activeCategory === category.name
                  ? "bg-white shadow-lg border-2 border-teal-500"
                  : "bg-white"
              } hover:shadow-md transition`}
            >
              <img
                className="text-3xl mb-2"
                src={category.icon}
                alt={category.name}
              />
              <span className="text-center text-sm font-medium">
                {category.name}
              </span>
            </button>
          ))}
        </div> */}

        <div className="space-y-8 mb-12 hidden md:block">
          {/* First Row with 5 items */}
          <div className="grid grid-cols-5 gap-4">
            {categories.slice(0, 5).map((category) => (
              <button
                key={category.name}
                onClick={() => setActiveCategory(category.name)}
                className={`flex flex-col items-center p-4 rounded-lg ${
                  activeCategory === category.name
                    ? "bg-white shadow-lg border-2 border-teal-500"
                    : "bg-white"
                } hover:shadow-md transition`}
              >
                <img
                  className="text-3xl mb-2"
                  src={category.icon}
                  alt={category.name}
                />
                <span className="text-center text-sm font-medium">
                  {category.name}
                </span>
              </button>
            ))}
          </div>
        </div>
        <div className="space-y-8 px-[10%] mb-12 hidden md:block">
          {/* Second Row with 4 centered items */}
          <div className="grid grid-cols-4 gap-4 justify-center">
            {categories.slice(5).map((category) => (
              <button
                key={category.name}
                onClick={() => setActiveCategory(category.name)}
                className={`flex flex-col items-center p-4 rounded-lg ${
                  activeCategory === category.name
                    ? "bg-white shadow-lg border-2 border-teal-500"
                    : "bg-white"
                } hover:shadow-md transition`}
              >
                <img
                  className="text-3xl mb-2"
                  src={category.icon}
                  alt={category.name}
                />
                <span className="text-center text-sm font-medium">
                  {category.name}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex">
          <aside className="hidden md:block w-1/4 pr-8">
            <h2 className="text-lg font-semibold py-8 px-4 mb-1">Category</h2>
            <ul>
              {categories.map((category) => (
                <li key={category.name} className="flex items-center">
                  <button
                    onClick={() => setActiveCategory(category.name)}
                    className={`block py-2 px-4 rounded ${
                      activeCategory === category.name
                        ? "text-[#187C85] font-bold"
                        : "text-gray-700"
                    } hover:bg-blue-50`}
                  >
                    <span className="flex">
                      <p>{category.name}</p>

                      <hr className="min-h-[2px] bg:teal-700"></hr>
                    </span>
                  </button>
                  <div
                    class={`${
                      activeCategory === category.name ? "block" : "hidden"
                    } flex-1 h-[1.5px] bg-[#187C8598]`}
                  ></div>

                  {/* <div className="h-[4px] bg:teal-700"></div> */}
                </li>
              ))}
            </ul>
          </aside>

          <div className="flex-1">
            <ul>
              {FAQTableDefault[activeCategory]?.map((faq, index) => (
                <div key={index} className="quesansdivfaq">
                  <button
                    className="w-full flex items-center justify-between p-8 text-left hover:bg-gray-50 group"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className="font-small pr-8 text-sm md:text-base font-weight-500 ">
                      {faq.question}
                    </span>
                    <img
                      src={
                        openIndex !== index
                          ? RedAccordianArrowDown
                          : TealAccordianArrowDown
                      }
                      alt="Accordion Arrow"
                      className={`transition-transform duration-200 ${
                        openIndex === index ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`overflow-hidden transition-max-height duration-300 ease-in-out ${
                      openIndex === index ? "max-h-50" : "max-h-0"
                    }`}
                  >
                    <div className="p-4 border-t border-gray-200">
                      <p
                        className="text-gray-600 text-sm faqAnswers"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    </div>
                  </div>
                  {faqs.length - 1 === index ? (
                    <></>
                  ) : (
                    <hr className="faq-saperator"></hr>
                  )}
                </div>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <HealthInsuranceHero />
    </>
  );
};
